import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors
} from '../../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  setSalesEntity: (defaultEntity) => ({ defaultEntity }),
  reset: () => null,
  asyncs: {
  }
}, 'lotPicking');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    rowModelType: 'serverSide',
    suppressEditDeleteInContextMenu: true,
  },
  Columns: [
    { headerName: 'Invoice', field: 'InvoiceNumber', type: 'numericColumn', minWidth: 100, },
    { headerName: 'Line', field: 'LineNo', minWidth: 100, suppressSorting: true, },
    { headerName: 'Sales entity', field: 'SalesEntity', minWidth: 120, suppressSorting: true, },
    { headerName: 'Quantity', field: 'QuantityDisplay', type: 'numericColumn', minWidth: 150, suppressSorting: true, },
    {
      headerName: 'Customer',
      field: 'CustomerIdDisplay',
      minWidth: 150,
      suppressSorting: true,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.CustomerId) {
          return {
            CustomerId: row.data.CustomerId,
            CustomerAccountNumber: row.data.CustomerIdDisplay,
            FieldValue: row.data.CustomerIdDisplay
          };
        } else return null;
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/customer-enquiry'
      }
    },
    { headerName: 'Name', field: 'CustomerName', suppressSorting: true, minWidth: 250, }
  ],
  Data: [],
  selectedFilters: {
    SalesEntity: '',
    CustomerId: 0,
  },
  filterRow: {
    formName: 'IEStockingQuantitiesPickingFilters',
    hidePreFilters: true,
    parameters: [
      {
        id: 0,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Sales entity',
          name: 'SalesEntity',
          lookupName: 'SalesEntity',
          size: 'small',
          required: false
        }
      },
      {
        id: 1,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Customer',
          name: 'CustomerId',
          lookupName: 'Customer',
          size: 'small',
          required: false,
          searchScreenAPIParms: {Type: 'LOOKUP'}
        }
      }
    ]
  }
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.reset:
      return {
        ...state,
        data: initialState.data
      };
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
   
    default:
      return state
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.stocking.lotPicking,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.inventoryEnquiry.stocking.lotPicking.fetch_loading,
  gridOptions: state => state.inventoryEnquiry.stocking.lotPicking.data.gridOptions,
  columns: state => state.inventoryEnquiry.stocking.lotPicking.data.Columns,
  filterRow: state => state.inventoryEnquiry.stocking.lotPicking.data.filterRow,
  selectedFilters: state => state.inventoryEnquiry.stocking.lotPicking.data.selectedFilters,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)